module.exports = __webpack_public_path__ + "static/media/5DPO21.64f613b2.jpg";